import { SxProps, Theme } from '@mui/material';

import { themeColors } from '@/config/theme/themeColors.ts';
import { typography } from '@/config/theme/typography.ts';

export const FormFieldLabelBasicStyles: SxProps<Theme> = {
  ...typography.f12Regular,
  color: themeColors.greyDark,
  fontFamily: typography.fontFamily,
};

export const FormFieldLabelStyles: SxProps<Theme> = {
  ...FormFieldLabelBasicStyles,
  left: 0,
  position: 'absolute',
  top: -20,
};
